/** @format */

import { defaultActions } from '../actionsDefault';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { PureComponent } from 'react';
import { notificationConstants } from '../../modules/notifications/notifications';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';

const _ = require('underscore');

export class ItemLoaders {
    protected dispatch: any;

    protected component: PureComponent | null;

    constructor(dispatch: any) {
        this.dispatch = dispatch;
        this.component = null;
    }

    setPureComponnet = (component: PureComponent): void => {
        this.component = component;
    };

    getPureComponent = (): PureComponent | null => {
        return this.component;
    };

    deleteCall(
        uri: string,
        actionType: string,
        callback: any,
        options: { dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean; propagateDataToCallback?: boolean } = {}
    ): void {
        this.dispatch(defaultActions.remove(uri, actionType, callback, options));
    }

    deleteWithCallback(
        uri: string,
        actionType: string,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: { disableDefaultNotification?: boolean } = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        const defCallback = this.getDefDeleteCallBack(callback, callbackOptions);
        this.dispatch(
            defaultActions.remove(uri, actionType, defCallback, { propagateDataToCallback, dispatchAfterCallback, dispatchErrorAfterCallback })
        );
    }

    paginationCall(uri: string, actionType: string): void {
        this.dispatch(defaultActions.getCollection(FormGeneralHelper.getByUri(uri), [], [], actionType, null, {}));
    }

    paginationCallWithCallback(uri: string, actionType: string, callBack: any | null, option: object): void {
        this.dispatch(defaultActions.getCollection(FormGeneralHelper.getByUri(uri), [], [], actionType, callBack, option));
    }

    getSimple(uri: string, actionType: string): void {
        this.dispatch(defaultActions.get(uri, actionType, null));
    }

    getWithCallback(
        uri: string,
        actionType: string,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: {} = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        this.dispatch(
            defaultActions.getItem(uri, actionType, callback, { propagateDataToCallback, dispatchAfterCallback, dispatchErrorAfterCallback })
        );
    }

    getResponseWithCallback(
        uri: string,
        actionType: string,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: {} = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        this.dispatch(
            defaultActions.getItemWithFullResponse(uri, actionType, callback, {
                propagateDataToCallback,
                dispatchAfterCallback,
                dispatchErrorAfterCallback,
            })
        );
    }

    getListSimple(uri: string, actionType: string, filters: any, orders: any): void {
        this.dispatch(defaultActions.getCollection(uri, filters, orders, actionType, null, {}));
    }

    getListWithCallback(
        uri: string,
        actionType: string,
        filters: Array<Filter>,
        orders: Array<Order>,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: {} = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        this.dispatch(
            defaultActions.getCollection(uri, filters, orders, actionType, callback, {
                propagateDataToCallback,
                dispatchAfterCallback,
                dispatchErrorAfterCallback,
            })
        );
    }

    postWithCallback(
        uri: string,
        actionType: string,
        params: any,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: { disableDefaultNotification?: boolean } = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        const defCallback = this.getDefCallBack(callback, callbackOptions);
        this.dispatch(
            defaultActions.post(uri, params, actionType, defCallback, { propagateDataToCallback, dispatchAfterCallback, dispatchErrorAfterCallback })
        );
    }

    multiPostWithCallback(
        uri: string,
        actionType: string,
        mutliObject: any,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: { disableDefaultNotification?: boolean } = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        const defCallback = this.getDefCallBack(callback, callbackOptions);
        this.dispatch(
            defaultActions.multiPostSingleContext(uri, mutliObject, actionType, defCallback, {
                propagateDataToCallback,
                dispatchAfterCallback,
                dispatchErrorAfterCallback,
            })
        );
    }

    putWithCallback(
        uri: string,
        actionType: string,
        params: any,
        callback: any,
        options: { propagateDataToCallback?: boolean; dispatchAfterCallback?: boolean; dispatchErrorAfterCallback?: boolean } = {},
        callbackOptions: { disableDefaultNotification?: boolean } = {}
    ): void {
        const { propagateDataToCallback = true, dispatchAfterCallback = false, dispatchErrorAfterCallback = false } = options;

        const defCallback = this.getDefCallBack(callback, callbackOptions);
        this.dispatch(
            defaultActions.put(uri, params, actionType, defCallback, { propagateDataToCallback, dispatchAfterCallback, dispatchErrorAfterCallback })
        );
    }

    getDefCallBack = (callback: any, callbackOptions: { disableDefaultNotification?: boolean }): object => {
        if (typeof callback === 'object' && callback.onSuccess !== null && callback.onError !== null) {
            return callback;
        }
        const { disableDefaultNotification = false } = callbackOptions;
        return {
            onSuccess: (data: any): void => {
                if (callback) {
                    callback(data);
                    if (!disableDefaultNotification) {
                        NotificationHelper.notifySaveSuccess(this.dispatch);
                    }
                }
            },
            onError: (error: any): void => {
                this.dispatch({ type: notificationConstants.ERROR, error: error });
            },
        };
    };

    getDefDeleteCallBack = (callback: any, callbackOptions: { disableDefaultNotification?: boolean }): object => {
        if (typeof callback === 'object' && callback.onSuccess !== null && callback.onError !== null) {
            return callback;
        }
        const { disableDefaultNotification = false } = callbackOptions;
        return {
            onSuccess: (data: any): void => {
                if (callback) {
                    callback(data);
                    if (!disableDefaultNotification) {
                        NotificationHelper.notifySaveSuccess(this.dispatch);
                    }
                }
            },
            onError: (error: any): void => {
                this.dispatch({ type: notificationConstants.ERROR, error: error });
            },
        };
    };

    storeSetFilter = <T>(arg: T): void => {
        if (!this.component) {
            return;
        }
        this.component.setState({ filters: arg });
    };

    storeSetOrders = <T>(arg: T): void => {
        if (!this.component) {
            return;
        }
        this.component.setState({ orders: arg });
    };

    getStoreFilters = <T>(): T | null => {
        if (!this.component) {
            return null;
        }
        return _.propertyOf(this.component.state)('filters');
    };

    getStoreOrders = <T>(): T | null => {
        if (!this.component) {
            return null;
        }
        return _.propertyOf(this.component.state)('orders');
    };

    storeUpdateState = <T>(name: string, value: T, callback: any | null): void => {
        if (!this.component) {
            return;
        }
        const elm: T | null = _.propertyOf(this.component.state)(name);
        if (!elm) {
            return;
        }
        this.component.setState({ [name]: value }, (): void => {
            if (callback) {
                callback();
            }
        });
    };
}
